import { render, staticRenderFns } from "./SearchBoxNeighCompare.vue?vue&type=template&id=5b910493&scoped=true"
import script from "./SearchBoxNeighCompare.vue?vue&type=script&lang=js"
export * from "./SearchBoxNeighCompare.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxNeighCompare.vue?vue&type=style&index=0&id=5b910493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b910493",
  null
  
)

export default component.exports